<template>
  <div class="home">
    <admin-header class="animated slideInDown"></admin-header>
    <div class="container-fluid">
      <div class="row" style="background-color: #f8f8f8;min-height: 665px;">
        <div
          class="my-menu col-lg-auto col-12 p-0 bg-white shadow animated fadeInLeft"
        >
          <admin-menu class="d-lg-block h-100"></admin-menu>
        </div>
        <div
          class="main col animated fadeInUp overflow-auto h-100"
          style="background: #f7f7f7"
        >
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminHeader from "../components/common/AdminHeader";
import AdminMenu from "../components/common/AdminMenu";
export default {
  name: "Home",
  components: { AdminHeader, AdminMenu }
};
</script>
